import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { usePricingContext } from '../context/PricingContext';
interface PremiumPriceCardProps {
  ctaLabel: string;
  embedded?: boolean;
}
export function PremiumPriceCard({
  ctaLabel,
  embedded = false
}: PremiumPriceCardProps) {
  const {
    cartLink,
    fireAddToCart
  } = usePricingContext();
  return <div className="flex flex-col items-center text-center w-full" style={embedded ? {
    background: 'transparent'
  } : {
    background: '#EFE7D8',
    border: '1px solid rgba(200,169,106,0.35)',
    borderRadius: '1rem',
    boxShadow: '0 4px 24px rgba(60,40,10,0.09), inset 0 1px 0 rgba(255,255,255,0.45)',
    overflow: 'hidden'
  }} data-id="element-115">
      {/* ── Savings badge ── */}
      <div className="w-full py-2 text-center" style={{
      background: 'rgba(139,32,32,0.08)',
      borderBottom: '1px solid rgba(139,32,32,0.14)',
      borderRadius: embedded ? 0 : '1rem 1rem 0 0'
    }} data-id="element-116">
        <span className="text-xs font-bold uppercase tracking-widest" style={{
        color: '#8B2020'
      }} data-id="element-117">
          AHORRAS 90% HOY
        </span>
      </div>

      <div className="px-5 pt-5 pb-5 w-full" data-id="element-118">
        {/* ── Layer 1: Value Anchor (compare price, strikethrough) ── */}
        <p className="text-xs font-bold uppercase tracking-widest mb-1" style={{
        color: '#9A9A9A'
      }} data-id="element-119">
          Valor regular:
        </p>
        <p className="font-serif text-lg font-bold mb-4" style={{
        color: '#9A9A9A',
        textDecoration: 'line-through',
        textDecorationColor: 'rgba(139,32,32,0.45)',
        opacity: 0.65
      }} data-id="element-120">
          <PriceDisplay type="compare" data-id="element-121" />
        </p>

        {/* ── Gold divider ── */}
        <div className="w-full mb-4" style={{
        height: '1px',
        background: 'linear-gradient(90deg, transparent, rgba(200,169,106,0.45), transparent)'
      }} data-id="element-122" />

        {/* ── Layer 2: Offer Statement ── */}
        <p className="text-xs font-bold uppercase mb-3" style={{
        color: '#3A3020',
        letterSpacing: '0.07em'
      }} data-id="element-123">
          HOY ACCEDÉS POR UN PAGO ÚNICO DE:
        </p>

        {/* ── Layer 3: Main Price — large, gold gradient ── */}
        <div className="font-black text-gold-gradient" style={{
        fontFamily: 'Merriweather, serif',
        fontSize: 'clamp(2.8rem, 11vw, 4rem)',
        lineHeight: 1.05,
        marginBottom: '6px'
      }} data-id="element-124">
          <PriceDisplay type="current" data-id="element-125" />
        </div>

        <p className="text-xs mb-5" style={{
        color: '#6A6050',
        letterSpacing: '0.02em'
      }} data-id="element-126">
          Pago único · Acceso de por vida
        </p>

        {/* ── Layer 4: CTA ── */}
        <a href={cartLink} className="block w-full mb-4" onClick={fireAddToCart} data-id="element-127">
          <button className="btn-sacred w-full text-lg py-4 font-serif tracking-wide rounded-xl" data-id="element-128">
            {ctaLabel}
          </button>
        </a>

        {/* ── Trust Bar ── */}
        <div className="grid grid-cols-2 gap-x-2 gap-y-2 pt-3" style={{
        borderTop: '1px solid rgba(200,169,106,0.2)'
      }} data-id="element-129">
          {['Pago único', 'Sin suscripciones', 'Acceso de por vida', 'Pago 100% Seguro'].map(item => <span key={item} className="flex items-center gap-1 text-xs justify-center" style={{
          color: '#6A6050'
        }} data-id="element-130">
              <CheckCircle2 className="w-3 h-3 flex-shrink-0" style={{
            color: '#1A6B3A'
          }} data-id="element-131" />
              {item}
            </span>)}
        </div>
      </div>
    </div>;
}